/**
 * Urlハイライトwatch用mixin
 */
export default {
  watch: {
    // link部分のハイライトは表示の度に再生成が必要
    highlightMode: {
      async handler () {
        if (!this.highlightMode) return // ハイライトモードではない時は処理skip
        await this.$nextTick()
        this.getArrayAnyCommentHighlights(this.urlHighlightTargetIds)
          .forEach((commentHighlight) => {
            this.setHighlight(commentHighlight)
          })
      }
    }
  }
}
